
























import Vue from 'vue';
import { get } from 'lodash';
import gql from 'graphql-tag';
import DashboardDrilldownCell from './DashboardDrilldownCell';

export default Vue.extend({
  name: 'DashboardDrilldownRow',
  components: {
    DashboardDrilldownCell,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    source: {
      type: Object,
      default: () => null,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      attributes: null,
    };
  },
  apollo: {
    attributes: {
      query: gql`
        query GetDrilldownColumnsAttributes($id: ID!, $names: [String]!) {
          node(id: $id) {
            attrs(names: $names) {
              __typename
              attr {
                name
              }
            }
          }
        }
      `,
      variables() {
        const { id } = this.source;
        return {
          id,
          names: this.columns,
        };
      },
      update(result) {
        let attributes = get(result, 'node.attrs', []);
        attributes = attributes.filter(attribute => attribute);
        return attributes.map(attribute => ({
          type: attribute.__typename,
          name: get(attribute, 'attr.name'),
        }));
      },
      skip() {
        return !this.columns;
      },
    },
  },
  computed: {
    even() {
      return this.index % 2 == 0;
    },
  },
  methods: {
    onRowClick() {
      if (window.analytics) {
        analytics.track('dashboard_drilldown_click', {
          metric: this.source.type,
          url: this.$route.fullPath,
        });
      }
      window.open(`/sor/info/${this.source.type}/${this.source.dbId}/info`, '_blank');
    },
  },
});
